/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_cat_science = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Science and lab calculators — molarity and dilutions, PCR master mix, DNA/RNA molecular weight, GC content, protein translation, boiling point at reduced pressure and HPLC method transfer.`)
};

const es_about_cat_science = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras científicas y de laboratorio — molaridad y diluciones, mezcla maestra de PCR, peso molecular de ADN/ARN, contenido de GC, traducción de proteínas, punto de ebullición a presión reducida y transferencia de método HPLC.`)
};

const de_about_cat_science = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wissenschafts- und Laborrechner — Molarität und Verdünnungen, PCR-Mastermix, DNA/RNA-Molekulargewicht, GC-Gehalt, Proteintranslation, Siedepunkt bei vermindertem Druck und HPLC-Methodentransfer.`)
};

const nl_about_cat_science = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wetenschaps- en laboratoriumrekentools — molariteit en verdunningen, PCR-mastermix, DNA/RNA-molecuulgewicht, GC-gehalte, eiwittranslatie, kookpunt bij verlaagde druk en HPLC-methodeoverdracht.`)
};

const fr_about_cat_science = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrices scientifiques et de laboratoire — molarité et dilutions, mix maître PCR, poids moléculaire ADN/ARN, teneur en GC, traduction de protéines, point d’ébullition à pression réduite et transfert de méthode HPLC.`)
};

const it_about_cat_science = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatrici scientifiche e di laboratorio — molarità e diluizioni, master mix per PCR, peso molecolare di DNA/RNA, contenuto di GC, traduzione proteica, punto di ebollizione a pressione ridotta e trasferimento di metodo HPLC.`)
};

const pt_br2_about_cat_science = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras científicas e de laboratório — molaridade e diluições, mix mestre de PCR, peso molecular de DNA/RNA, teor de GC, tradução de proteínas, ponto de ebulição sob pressão reduzida e transferência de método HPLC.`)
};

const pt_about_cat_science = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras científicas e de laboratório — molaridade e diluições, mix mestre de PCR, peso molecular de ADN/ARN, teor de GC, tradução de proteínas, ponto de ebulição sob pressão reduzida e transferência de método HPLC.`)
};

const ja_about_cat_science = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`科学・実験計算機 — モル濃度と希釈、PCRマスターミックス、DNA/RNA分子量、GC含有量、タンパク質翻訳、減圧下の沸点、HPLCメソッド移行。`)
};

const zh_about_cat_science = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`科学与实验室计算器 — 摩尔浓度与稀释、PCR 主混合液、DNA/RNA 分子量、GC 含量、蛋白质翻译、减压沸点以及 HPLC 方法转移。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_cat_science = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_cat_science(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_cat_science", locale)
	if (locale === "en") return en_about_cat_science(inputs)
	if (locale === "es") return es_about_cat_science(inputs)
	if (locale === "de") return de_about_cat_science(inputs)
	if (locale === "nl") return nl_about_cat_science(inputs)
	if (locale === "fr") return fr_about_cat_science(inputs)
	if (locale === "it") return it_about_cat_science(inputs)
	if (locale === "pt-BR") return pt_br2_about_cat_science(inputs)
	if (locale === "pt") return pt_about_cat_science(inputs)
	if (locale === "ja") return ja_about_cat_science(inputs)
	return zh_about_cat_science(inputs)
};